import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddCurrencyModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import { DetailTable } from "@/components/Tables/DetailTable"
import { apiFetch } from "@/hooks/apiFetch"
import { useEffect, useState } from "react"

export default function DenominationSettingList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Attribute Type" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Currency Config</h5>
      </div>

      <CrudProvider>
        <DenominationList />
      </CrudProvider>
    </>
  )
}

function DenominationList() {
  const { openDialog } = useCrudContext();
  const [currencies, setCurrencies] = useState([]);

  const transferData = (arr) => {
    return arr.map((item) => ({key: 'note', value: item}))
  }

  useEffect(() => {
    apiFetch('cash/currencies-notes')
      .then((res) => {
        const arrayOfNotes = transferData(res.denominations.npr)
        setCurrencies(arrayOfNotes)
        console.log('curr', arrayOfNotes)
    })
  }, []);
  const col = [
    {
      header: "Notes",
      accessorKey: 'note'
    },
    {
      header: "Amount",
      accessorKey: 'value'
    }
  ]

  return (
    <>
      <CustomTable
        label="Currencies"
        columns={columns}
        apiPath="settings"
        hardcodedFilters={{ key: "currency" }}
      />

      {/* <DetailTable
        label="Denominations"
        columns={col}
        data={currencies}
        isLoading={false}
      /> */}

      {openDialog ? <AddCurrencyModal /> : null}
    </>
  )
}
